export enum AppModes {
  OnBoarding = 'ON_BOARDING',
  DocumentShare = 'DOCUMENT_SHARE',
  PasswordReset = 'RESET_PASSWORD'
}

export type modeText = {
  [AppModes.OnBoarding]: string;
  [AppModes.DocumentShare]: string;
  [AppModes.PasswordReset]: string;
};

export function getAppModeFromString(appModeString: string): AppModes {
  switch (appModeString) {
    case AppModes.OnBoarding:
      return AppModes.OnBoarding;
    case AppModes.DocumentShare:
      return AppModes.DocumentShare;
    case AppModes.PasswordReset:
      return AppModes.PasswordReset;
    default:
      return AppModes.OnBoarding;
  }
}
